import { ViewObserver, ViewObserverEvent } from '~/utils/view-observer.js';

export default {
    inserted: (el, binding, ) => {
        function handleIntersect() {
            binding.value();
        }

        ViewObserver.observe(el);

        el.addEventListener(
            ViewObserverEvent.VIEW_ENTER,
            handleIntersect
        );
    },
    unbind: (el) => {
        ViewObserver.unobserve(el);
    }
};
